<script setup>
import { ref } from 'vue'
import { CRITERIA } from '../lib/criteria.js'

defineProps({
  settings: { type: Object, required: true },
  pipelines: { type: Array, default: () => [] },
})
const emit = defineEmits(['reset'])

const abierto = ref(false)
const UMBRALES = [
  { key: 'stagnantDays', label: 'Dias sin cambiar de etapa', criterio: 'ETAPA_ESTANCADA' },
  { key: 'noActivityDays', label: 'Dias sin actividad', criterio: 'SIN_ACTIVIDAD' },
  { key: 'firstStageDays', label: 'Dias en la etapa inicial', criterio: 'NUNCA_AVANZO' },
  { key: 'contactGraceDays', label: 'Margen antes de exigir oportunidad', criterio: 'SIN_OPORTUNIDAD' },
]
const ESTADOS = ['open', 'won', 'lost', 'abandoned']

function toggleEstado(settings, estado, checked) {
  const set = new Set(settings.statuses)
  checked ? set.add(estado) : set.delete(estado)
  settings.statuses = [...set]
}

function overrideDe(settings, pipelineId, key) {
  return settings.perPipeline?.[pipelineId]?.[key] ?? ''
}

function setOverride(settings, pipelineId, key, value) {
  const actual = { ...(settings.perPipeline[pipelineId] || {}) }
  if (value === '' || value === null) delete actual[key]
  else actual[key] = Number(value)
  const siguiente = { ...settings.perPipeline }
  Object.keys(actual).length ? (siguiente[pipelineId] = actual) : delete siguiente[pipelineId]
  settings.perPipeline = siguiente
}
</script>

<template>
  <div class="card panel no-print">
    <div class="row" @click="abierto = !abierto" style="cursor: pointer">
      <h2 class="grow">Criterios de "no gestionado"</h2>
      <span class="muted">{{ abierto ? 'ocultar' : 'ajustar umbrales' }}</span>
    </div>

    <div v-if="abierto" class="body">
      <section>
        <h3>Criterios activos</h3>
        <div class="criterios">
          <label v-for="c in Object.values(CRITERIA)" :key="c.id" class="criterio" :title="c.help">
            <input type="checkbox" v-model="settings.enabled[c.id]" />
            <span>
              <strong>{{ c.label }}</strong>
              <em>{{ c.help }}</em>
            </span>
          </label>
        </div>
      </section>

      <section>
        <h3>Umbrales globales</h3>
        <div class="umbrales">
          <label v-for="u in UMBRALES" :key="u.key" :class="{ off: !settings.enabled[u.criterio] }">
            <span>{{ u.label }}</span>
            <input type="number" min="0" max="365" v-model.number="settings[u.key]" />
          </label>
        </div>
      </section>

      <section>
        <h3>Estados de oportunidad evaluados</h3>
        <div class="row">
          <label v-for="e in ESTADOS" :key="e" class="chip">
            <input
              type="checkbox"
              :checked="settings.statuses.includes(e)"
              @change="toggleEstado(settings, e, $event.target.checked)"
            />
            <span>{{ e }}</span>
          </label>
        </div>
      </section>

      <section v-if="pipelines.length">
        <h3>Umbrales por pipeline <span class="muted">(vacio = usa el global)</span></h3>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Pipeline</th>
                <th class="right">Dias sin cambiar etapa</th>
                <th class="right">Dias sin actividad</th>
                <th class="right">Dias etapa inicial</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in pipelines" :key="p.id">
                <td>{{ p.name }}</td>
                <td v-for="k in ['stagnantDays', 'noActivityDays', 'firstStageDays']" :key="k" class="right">
                  <input
                    type="number" min="0" max="365"
                    :placeholder="String(settings[k])"
                    :value="overrideDe(settings, p.id, k)"
                    @input="setOverride(settings, p.id, k, $event.target.value)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <div class="row">
        <button class="ghost" @click="emit('reset')">Restablecer valores por defecto</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.panel { padding: 14px 16px; margin-bottom: 16px; }
.body { display: grid; gap: 18px; margin-top: 14px; padding-top: 14px; border-top: 1px solid var(--border); }
section { display: grid; gap: 8px; }
.criterios { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 8px; }
.criterio { display: flex; gap: 8px; align-items: flex-start; padding: 8px 10px; border: 1px solid var(--border); border-radius: 8px; }
.criterio span { display: grid; }
.criterio em { font-style: normal; font-size: 12px; color: var(--muted); }
.umbrales { display: flex; flex-wrap: wrap; gap: 14px; }
.umbrales label { display: grid; gap: 4px; font-size: 12px; color: var(--muted); }
.umbrales label.off { opacity: .45; }
.chip { display: inline-flex; gap: 6px; align-items: center; padding: 5px 10px; border: 1px solid var(--border); border-radius: 999px; font-size: 12px; }
</style>
